module.exports = __webpack_public_path__ + "img/changeCard.e2e2e9d3.png";